export * from './tour-info.service';
export * from './tour-info.module';
